import React from 'react';
import { useGame } from '../context/GameContext';
import GameCard from '../components/GameCard';
import { canUpgrade } from '../game/cards';
import { ArrowLeft, TrendingUp } from 'lucide-react';

export default function CardUpgrade() {
  const { run, confirmUpgradeCard, cancelUpgradeCard } = useGame();
  if (!run) return null;
  return (
    <div className="min-h-screen w-full px-6 py-6">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={cancelUpgradeCard} data-testid="upgrade-back-button">
          <ArrowLeft size={16} /> BACK
        </button>
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-[color:var(--neon)] flex items-center gap-3">
          <TrendingUp /> UPGRADE A CARD
        </h1>
        <div className="w-24" />
      </div>
      <div className="mt-4 text-center text-sm uppercase tracking-widest text-[color:var(--text-dim)]">
        pick one to make it thiccer (+dmg / +block / -cost)
      </div>

      <div className="mt-10 flex flex-wrap gap-4 justify-center" data-testid="upgrade-cards-list">
        {run.player.deck.map((cid, i) => {
          const upgradable = canUpgrade(cid);
          return (
            <div key={i} className="flex flex-col items-center gap-2">
              <div onClick={() => upgradable && confirmUpgradeCard(i)} style={{ opacity: upgradable ? 1 : 0.35, cursor: upgradable ? 'pointer' : 'not-allowed' }}>
                <GameCard cardId={cid} testid={`upgrade-slot-${i}`} disabled={!upgradable} />
              </div>
              {!upgradable && (
                <div className="text-[10px] uppercase tracking-widest text-[color:var(--red)]">MAX / N/A</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
